import { cn } from "@/shared/utils/cn";

type Props = {
  src: string;
  alt: string;
  size?: number;
  ring?: "none" | "rose" | "amber" | "violet";
  className?: string;
};

export function Avatar({ src, alt, size = 40, ring = "none", className }: Props) {
  const ringClass =
    ring === "rose"
      ? "p-[2px] bg-gradient-to-tr from-rose-300 via-amber-200/80 to-rose-400"
      : ring === "amber"
      ? "p-[2px] bg-gradient-to-tr from-amber-200 via-rose-200/80 to-amber-300"
      : ring === "violet"
      ? "p-[2px] bg-gradient-to-tr from-violet-300 via-rose-200/80 to-violet-400"
      : "";
  return (
    <div
      className={cn("rounded-full overflow-hidden", ringClass, className)}
      style={{ width: size, height: size }}
    >
      <div className={cn("rounded-full overflow-hidden w-full h-full", ring !== "none" && "border-[3px] border-velvet")}>
        <img
          src={src}
          alt={alt}
          width={size}
          height={size}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
}
